export default "__VITE_ASSET__b96520cc__"